import React from 'react'

const ProjectsDb = () => {
  return (
    <div>ProjectsDb</div>
  )
}

export default ProjectsDb